import React from 'react';

export default function Footer() {
    return (
        <div className = "Footer">
            <div  className = "Footer-copyright">@Copyright Cabreras Mexican Bar & Grill, 2020</div>

            <div className = "Footer-Icons">
                <i className="fab fa-twitter"/>
                <i className="fab fa-facebook-square"/>
                <i className="fab fa-instagram"/>
            </div>
        </div>
    )
}
